import { BaseComponent } from './base.component';
import { Component, OnInit, Input, Output, EventEmitter, Directive } from '@angular/core';
import { EventBusService } from '@library-shared/services/event-bus/event-bus.service';
import { EventBusEventTypeBase } from '@library-shared/services/event-bus/event-bus-event-type-base';

@Directive()
export class BaseDialog extends BaseComponent implements OnInit {
    _visible = false;
    @Input()
    get visible(): boolean {
        return this._visible;
    }
    set visible(value) {
        //this.log.data('visible:' + value);
        this._visible = value;
        this.visibleChanged.emit(this._visible);
    }
    @Output() visibleChanged = new EventEmitter<boolean>();

    isVisible = false;

    constructor(public eventBusService: EventBusService) {
        super();
        this.eventBusService.changeEmitted.subscribe((data) => {
            if (data.EventType === EventBusEventTypeBase.Logout) {
                this.visible = false;
            }
        });
    }

    showDialogBase() {
        this.visible = true;
    }

    closeDialogBase() {
        this.visible = false;
    }

    ngOnInit() {}

    onBaseShown() {
        this.isVisible = true;
    }

    onBaseHidden() {
        this.isVisible = false;
    }
}
